var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShortAnswerType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.875 22.8H20.125C20.9189 22.8 21.5625 22.2628 21.5625 21.6V2.4C21.5625 1.73726 20.9189 1.2 20.125 1.2H2.875C2.08109 1.2 1.4375 1.73726 1.4375 2.4V21.6C1.4375 22.2628 2.08109 22.8 2.875 22.8ZM20.125 24H2.875C1.28718 24 0 22.9255 0 21.6V2.4C0 1.07452 1.28718 0 2.875 0H20.125C21.7128 0 23 1.07452 23 2.4V21.6C23 22.9255 21.7128 24 20.125 24Z",
    fill: "#001B4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9637 5.28524L16.6054 4.80295L13.2588 7.83792L13.1469 8.34298L13.6171 8.3202L16.9637 5.28524ZM13.8299 8.93444L12.4194 9.00275L12.755 7.4876L16.6836 3.9248L17.7585 5.37165L13.8299 8.93444Z",
    fill: "#001B4A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4949 3.90047L18.1366 3.41819L17.7001 3.81405L18.0584 4.29634L18.4949 3.90047ZM18.5731 3.02232L18.9314 3.5046C19.1293 3.77097 19.0943 4.16412 18.8532 4.38275L17.9802 5.17448L16.9053 3.72764L17.7783 2.9359C18.0194 2.71727 18.3753 2.75596 18.5731 3.02232Z",
    fill: "#001B4A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 10,
    width: 15,
    height: 1.3875,
    rx: 0.554498,
    fill: "#001B4A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 12.775,
    width: 15,
    height: 1.3875,
    rx: 0.554498,
    fill: "#001B4A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 15.55,
    width: 15,
    height: 1.3875,
    rx: 0.554498,
    fill: "#001B4A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 18.325,
    width: 15,
    height: 1.3875,
    rx: 0.554498,
    fill: "#001B4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortAnswerType);
export default __webpack_public_path__ + "static/media/short-answer-type.dec0a91de278f130619bbc39cf96de03.svg";
export { ForwardRef as ReactComponent };